import React, { PureComponent } from 'react';
import { string, number, bool, shape } from 'prop-types';
import { logger } from '@fiverr-private/perseus';
import { I18n } from '@fiverr-private/fiverr_context';
import SafeComponent from '../shared/SafeComponent';
import getRecommendationsData from '../../utils/getRecommendationsData';
import GigCarouselWrapper from '../shared/GigCarouselWrapper';
import { getGigIds } from '../../utils/browsingHistory';
import { INSPIRED_BY_VIEWS, MINIMUM_ITEMS } from '../../utils/constants/recommendations';

const buildAjaxQueryParams = () => {
    const gigIds = getGigIds();
    if (!gigIds.length) {
        return;
    }

    return { gig_ids: gigIds, type: INSPIRED_BY_VIEWS };
};

class InspiredByRecentViews extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            gigs: [],
            isLoading: true
        };

        this.fetchRecommendations = this.fetchRecommendations.bind(this);
    }

    componentDidMount() {
        this.fetchRecommendations();
    }

    hasMinimumItems(){
        const { gigs } = this.state;

        return gigs && gigs.length >= MINIMUM_ITEMS;
    }

    async fetchRecommendations() {
        const queryParams = buildAjaxQueryParams();
        if (!queryParams) {
            this.setState({
                isLoading: false
            });

            if (this.hasSufficientCookies()) {
                logger.warn({ message: 'Empty gigs in local storage' });
            }

            return;
        }

        try {
            const { gigs } = await getRecommendationsData(queryParams);
            this.setState({
                gigs,
                isLoading: false
            });
        } catch {
            this.setState({
                isLoading: false
            });
        }
    }

    hasSufficientCookies() {
        const { lastGigInCookie, userWasLoggedIn } = this.props;

        return !!lastGigInCookie && !userWasLoggedIn;
    }

    shouldRenderCarousel() {
        const { isLoading } = this.state;

        return this.hasSufficientCookies() &&
            (this.hasMinimumItems() || (!this.hasMinimumItems() && isLoading));
    }

    render() {
        const { currency } = this.props;
        const { gigs, isLoading } = this.state;

        if (!this.shouldRenderCarousel()) {
            return null;
        }

        return (
            <GigCarouselWrapper gigs={gigs}
                boxClass={INSPIRED_BY_VIEWS}
                boxTitle={<I18n k="logged_out_homepage.recommendations.recently_viewed_and_more.title"/>}
                carouselPosition={1}
                currency={currency}
                isLoading={isLoading}/>
        );
    }
}

InspiredByRecentViews.propTypes = {
    currency: shape({
        name: string,
        rate: number,
        template: string,
        forceRound: bool,
        forceRoundFromAmount: number
    }),
    lastGigInCookie: number,
    userWasLoggedIn: bool
};

export { InspiredByRecentViews };
export default SafeComponent(InspiredByRecentViews);
